import React from 'react';
import * as styles from './LoadingIndicator.css';

const LoadingIndicator = (): React.ReactElement => (
    <div className={styles.loader} />
);

export default LoadingIndicator;
